import { Empty, Image, Tooltip } from 'ant-design-vue'
import { defineComponent, type PropType } from 'vue'
import { LoadingOutlined, HourglassOutlined, CheckCircleOutlined, DeleteFilled } from '@ant-design/icons-vue'
import type { FileItem, FileStatusType } from './helper'
import styles from './CaptureList.module.less'
const statusIcon: Record<FileStatusType, any> = {
  convering: <LoadingOutlined />,
  uploading: <LoadingOutlined />,
  convered: <HourglassOutlined />,
  uploaded: <CheckCircleOutlined />
}
const statusText: Record<FileStatusType, string> = {
  convering: '转换中',
  uploading: '上传中',
  convered: '待上传',
  uploaded: '已上传'
}
export default defineComponent({
  name: 'CaptureList',
  props: {
    list: {
      type: Array as PropType<FileItem[]>,
      default: () => []
    }
  },
  setup(props, ctx) {
    return () => (
      <div class={styles.capture}>
        <div class={styles.title}>图片列表({props.list.length})</div>
        <div class={styles.wrap} ref='wrap'>
          {props.list.length > 0 ? (
            <div class={styles.list}>
              {props.list.map(item => (
                <div class={styles.item}>
                  <div class={[styles[item.status], styles.status]}>
                    {statusIcon[item.status]}
                    <label>{statusText[item.status]}</label>
                  </div>
                  {item.status === 'convered' && (
                    <div
                      class={styles.remove}
                      onClick={() =>
                        ctx.emit(
                          'update:list',
                          props.list.filter(ele => ele.uid !== item.uid)
                        )
                      }
                    >
                      <DeleteFilled />
                    </div>
                  )}
                  <Image src={item.base64} width='200px' height='150px' />
                  <p class={styles.name}>
                    <Tooltip title={item.file?.name}>{item.file?.name}</Tooltip>
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <Empty />
          )}
        </div>
      </div>
    )
  }
})
